import { styled, Link } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  flexWrap: 'wrap',
  margin: theme.spacing(0),

  a: {
    width: '160px',
    flex: '0 0 160px',
  },

  [theme.breakpoints.up('md')]: {
    maxWidth: 1110,
    gap: theme.spacing(6),
    margin: theme.spacing(6, 12),
  },
}));

export const BeautyLink = styled(Link)(({ theme }) => ({
  fontSize: '1.7rem',
  textDecoration: 'none',
  flex: 1,
  [theme.breakpoints.up('md')]: {
    color: theme.palette.text.primary,
    display: 'block',
    lineHeight: theme.typography.pxToRem(21),

    textDecoration: 'none',
  },

  '&:hover, &:focus, &:active': {
    color: theme.palette.secondary.main,
    WebkitTapHighlightColor: 'transparent',
  },
}));

export const MobileList = styled('ul')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  listStyleType: 'none',

  li: {
    padding: theme.spacing(2, 3, 2, 10),
  },
}));
